import { useState, useEffect, useRef } from 'react';

const ApiSelectSearch = ({
  label = 'Select Option',
  getOptionLabel = (item) => item.name,
  getOptionValue = (item) => item.name,
  value = '',
  onChange = () => {},
  error = false,
  placeholder = '',
  disabled = false,
  minSearchLength = 1,
  useQueryHook,
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [showOptions, setShowOptions] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const inputRef = useRef(null);

  const { data: options = [], isLoading, refetch } = useQueryHook(searchTerm.trim().length >= minSearchLength ? searchTerm : '');

  useEffect(() => {
    if (value && selectedItem && getOptionValue(selectedItem) === value) {
      return;
    }
    setSearchTerm('');
  }, [value]);

  useEffect(() => {
    if (searchTerm.trim().length >= minSearchLength) {
      refetch();
    }
  }, [searchTerm, refetch, minSearchLength]);

  const handleSelect = (item) => {
    if (disabled) return;
    const val = getOptionValue(item);
    const label = getOptionLabel(item);
    console.log("sdfghjkjhfd",label,"mnbvcxxcv",item);
    setSelectedItem(item);
    setSearchTerm(label);
    onChange(val);
    setShowOptions(false);
  };

  return (
    <div className="custom-date-wrapper position-relative">
      <label
        className={`custom-date-label ${showOptions || searchTerm !== '' || value !== '' ? 'active-tab' : ''}`}
        htmlFor="searchSelectInput"
      >
        {label}
      </label>
      <input
        ref={inputRef}
        type="text"
        className={`form-control custom-date-input ${error ? 'errorborder' : ''}`}
        id="searchSelectInput"
        placeholder={placeholder}
        value={searchTerm == "" ? value : searchTerm}
        onChange={(e) => {
          if (!disabled) {
            if(e.target.value == ""){
              onChange("")
            }
            setSearchTerm(e.target.value);
            setShowOptions(true);
          }
        }}
        onFocus={() => !disabled && setShowOptions(true)}
        onBlur={() => setTimeout(() => setShowOptions(false), 400)}
        style={{
          fontSize: '0.8rem',
          padding: '0.375rem 11px',
          height: '30px',
          border: error ? '1px solid red' : '',
          backgroundColor: disabled ? '#f8f6f6' : 'white',
          cursor: disabled ? 'not-allowed' : 'text',
        }}
        autoComplete="off"
        readOnly={disabled}
      />
      
      {!disabled && showOptions && (
        <ul className="dropdown-menu show w-100 mt-1">
          {isLoading ? (
            <li className="dropdown-item text-muted" style={{ fontSize: '0.8rem' }}>
              Loading...
            </li>
          ) : options.data?.length > 0 ? (
            options.data.map((item, index) => (
              <li key={index}>
                <button
                  className="dropdown-item-custom"
                  type="button"
                  onClick={() => handleSelect(item)}
                  style={{ fontSize: '0.8rem' }}
                >
                  {getOptionLabel(item)}
                </button>
              </li>
            ))
          ) : searchTerm.trim().length >= minSearchLength ? (
            <li className="dropdown-item text-muted" style={{ fontSize: '0.8rem' }}>
              No results found
            </li>
          ) : (
            <li className="dropdown-item text-muted" style={{ fontSize: '0.8rem' }}>
              Type at least {minSearchLength} character{minSearchLength > 1 ? 's' : ''} to search
            </li>
          )}
        </ul>
      )}
    </div>
  );
};

export default ApiSelectSearch;